import { Col, Row } from 'react-simple-flex-grid';
import aiTemplateImage from '../images/ai_template_img.jpg';
import aiResultImage from '../images/ai_result.png';
import aIVisitorImage2 from '../images/ai_visitor_image.jpg';
import aiTemplateImage2 from '../images/ai_template_img2.jpg';
import aiResultImage2 from '../images/ai_result_img2.png';
import aIVisitorImage from '../images/ai_visitor_image2.jpg';
import { useInView } from 'react-intersection-observer';
import '../styles/GenAi.scss';

function GenAI() {
  const [technologiesGenAiSectionRef, technologiesGenAiSectionRefInView] =
    useInView({
      triggerOnce: true,
      threshold: 0.4,
    });

  const imagesData = [
    {
      items: [
        { title: 'Visitor Image', src: aIVisitorImage },
        { title: 'Generated Avatar', src: aiTemplateImage },
      ],
      result: { title: 'Guardian Badge', src: aiResultImage },
    },
    {
      items: [
        { title: 'Visitor Image', src: aIVisitorImage2 },
        { title: 'Generated Avatar', src: aiTemplateImage2 },
      ],
      result: { title: 'Guardian Badge', src: aiResultImage2 },
    },
  ];

  return (
    <div
      ref={technologiesGenAiSectionRef}
      className={
        technologiesGenAiSectionRefInView
          ? 'genai-wrapper slideInUp'
          : 'genai-wrapper'
      }
    >
      <h3 className="section-title">Gen AI</h3>
      <p className="genai-subtitle">for avatar generation</p>
      <div className="genai-content">
        <Row gutter={20}>
          <Col xs={12} sm={6}>
            <p className="content-text">
              A multimodal diffusion transformer (MMDiT) model creates a digital
              avatar of visitors by blending their facial features with a
              pre-made template, while an LLM generates their name and
              profession. 11Labs Generative Voice AI gives Alnair a voice, and
              NVIDIA Audio2Face syncs lips to words.
            </p>
          </Col>
        </Row>
      </div>
      <div className="ai-images">
        {imagesData.map((block, i) => (
          <Row gutter={30} className="ai-images-row" key={i}>
            <Col className="ai-images-col">
              <div className="ai-images-block">
                <div className="ai-images-content">
                  <Row gutter={10}>
                    {block.items.map((img, idx) => (
                      <Col span={6} key={idx}>
                        <div className="ai-image">
                          <h5 className="content-title">{img.title}</h5>
                          <img
                            className="content-img"
                            src={img.src}
                            alt={img.title}
                          />
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            </Col>

            <Col className="ai-images-col">
              <div className="ai-images-block last-block">
                <div className="ai-images-content">
                  <Row gutter={10}>
                    <Col span={12}>
                      <div className="ai-image">
                        <h5 className="content-title">{block.result.title}</h5>
                        <img
                          className="content-img"
                          src={block.result.src}
                          alt={block.result.title}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        ))}
      </div>
    </div>
  );
}

export default GenAI;
